import { useState } from 'react';

export function useSteps(total: number) {
  const [currentStep, setCurrentStep] = useState(1);
  const goToNextStep = () => {
    if (currentStep === 1) {
      setCurrentStep(prev => prev + 1);
    }
  };
  const goToPreviousStep = () => setCurrentStep(prev => prev - 1);

  return {
    currentStep,
    totalSteps: total,
    goToNextStep,
    goToPreviousStep
  };
}
